var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration pb-4"},[_vm._m(0),_c('AddFacilityDetails',{attrs:{"customer":2},on:{"submit":_vm.create}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('h3',{staticClass:"pb-3 px-1 mb-0"},[_vm._v("Add Facility Details")])])
}]

export { render, staticRenderFns }